import styled from 'styled-components';
import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
  createStyles({
    mb15: {
      'margin-bottom': '15px'
    },
    mr15: {
      'margin-right': '15px'
    },
    mb20: {
      'margin-bottom': '20px'
    },
    mt30: {
      'margin-top': '30px'
    },
    pdl10: {
      'padding-left': '10%'
    },
    'd-relative': {
      position: 'relative'
    },
    'card-success': {
      width: '37%',
      borderRadius: '15px'
    },
    'width30%': {
      width: '30%',
      borderRadius: '15px'
    },
    'width80%': {
      width: '80%',
      borderRadius: '15px'
    }
  })
);

export const FormLabel = styled.p`
  color: #102341;
  font-family: 'TTCommons';
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 18px;
`;

export const CenterRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const ButtonWrapper = styled.div`
  width: 25%;
  margin-top: 30px;
`;

export const Header = styled.div`
  padding: 3% 0 1% 10%;
`;

export const CardWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const CardTitle = styled.p`
  color: #12253f;
  font-family: 'TTCommons';
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  margin-bottom: 20px;
`;

export const TextCenter = styled.p`
  color: #6e84a3;
  font-family: 'TTCommons';
  font-size: 15px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
`;

export const ButtonBackWrapper = styled.div`
  width: 50%;
`;

export const ButtonBackToLogin = styled.button`
  background: none;
  border: none;
  color: #4c7cfd;
  font-family: 'TTCommons';
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 17px;
  margin-bottom: 11px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`;
